export class AwsPrincipal {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "iamArn",
            "baseName": "iamArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsPrincipal.attributeTypeMap;
    }
    constructor() {
    }
}
